'use client';

import { createContext, useContext } from 'react';

// The rail (ProductsRail) knows which slide is current; each slide's media needs to know whether
// it is that slide (inactive videos pause instead of playing off-screen). Server-rendered slides
// can't receive props from a client parent, so the rail wraps each slide in `SlideIndexContext`
// and publishes the current index in `ActiveSlideContext`. Outside a rail both are null → active.
export const ActiveSlideContext = createContext<number | null>(null);
export const SlideIndexContext = createContext<number | null>(null);

/** Whether the enclosing product slide is the current one (true outside a rail). */
export const useIsProductSlideActive = (isActive?: boolean) => {
  const current = useContext(ActiveSlideContext);
  const index = useContext(SlideIndexContext);
  if (isActive !== undefined) return isActive;
  if (current === null || index === null) return true;
  return current === index;
};
